export enum PublicParams {
    REGISTRATION_TOKEN = "emailToken",
}
